const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoxbag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 341",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M22.63,224.11V233a6.89,6.89,0,0,0,6.89,6.89h8.72a6.89,6.89,0,0,0,6.89-6.88l.06-8.92a6.75,6.75,0,0,0-6.74-6.73l-8.78,0a6.75,6.75,0,0,0-7,6.47A2.17,2.17,0,0,0,22.63,224.11Z",
    style: {
      fill: "#fb7558",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.26,192.45v8.94a6.89,6.89,0,0,0,6.89,6.89h8.71a6.88,6.88,0,0,0,6.89-6.89l.06-8.91a6.74,6.74,0,0,0-6.73-6.73l-8.78,0a6.77,6.77,0,0,0-7,6.47Z",
    style: {
      fill: "#fb7558",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.85,215.75v8.93a6.89,6.89,0,0,0,6.89,6.89h8.72a6.89,6.89,0,0,0,6.89-6.88l.06-8.92A6.75,6.75,0,0,0,33.67,209l-8.78,0a6.76,6.76,0,0,0-7,6.47C17.86,215.57,17.85,215.66,17.85,215.75Z",
    style: {
      fill: "#fb7558",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.63,258.15v8.93A6.89,6.89,0,0,0,29.52,274h8.72a6.89,6.89,0,0,0,6.89-6.88l.06-8.92a6.75,6.75,0,0,0-6.74-6.73l-8.78,0a6.75,6.75,0,0,0-7,6.47A2.17,2.17,0,0,0,22.63,258.15Z",
    style: {
      fill: "#fb7558",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.51,258.15v8.93A6.88,6.88,0,0,0,13.39,274h8.72A6.88,6.88,0,0,0,29,267.09l.06-8.92a6.75,6.75,0,0,0-6.73-6.73l-8.78,0a6.76,6.76,0,0,0-7,6.47Z",
    style: {
      fill: "#fb7558",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.51,252.77v8.94a6.89,6.89,0,0,0,6.88,6.89h8.72A6.88,6.88,0,0,0,29,261.71l.06-8.91a6.75,6.75,0,0,0-6.73-6.74l-8.78,0a6.77,6.77,0,0,0-7,6.47Z",
    style: {
      fill: "#fb7558",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.51,262.33v8.93a6.88,6.88,0,0,0,6.88,6.89h8.72A6.88,6.88,0,0,0,29,271.27l.06-8.92a6.75,6.75,0,0,0-6.73-6.73l-8.78,0a6.76,6.76,0,0,0-7,6.47Z",
    style: {
      fill: "#fb7558",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.87,262.33v8.93a6.88,6.88,0,0,0,6.89,6.89h8.71a6.88,6.88,0,0,0,6.89-6.88l.06-8.92a6.75,6.75,0,0,0-6.73-6.73l-8.78,0a6.76,6.76,0,0,0-7,6.47Z",
    style: {
      fill: "#fb7558",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.87,254v8.93a6.88,6.88,0,0,0,6.89,6.89h8.71a6.88,6.88,0,0,0,6.89-6.88l.06-8.92a6.75,6.75,0,0,0-6.73-6.73l-8.78,0a6.76,6.76,0,0,0-7,6.47Z",
    style: {
      fill: "#fb7558",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.28,241.43v8.93a6.89,6.89,0,0,0,6.89,6.89h8.72a6.89,6.89,0,0,0,6.89-6.88l.06-8.92a6.75,6.75,0,0,0-6.74-6.73l-8.77,0a6.76,6.76,0,0,0-7,6.47C11.29,241.25,11.28,241.34,11.28,241.43Z",
    style: {
      fill: "#fb7558",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.65,144.68v8.93a6.88,6.88,0,0,0,6.89,6.89h8.71a6.88,6.88,0,0,0,6.89-6.88l.06-8.92A6.75,6.75,0,0,0,32.47,138l-8.78,0a6.76,6.76,0,0,0-7,6.47Z",
    style: {
      fill: "#fb7558",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,210.37v8.94a6.9,6.9,0,0,0,6.89,6.89H43.6a6.9,6.9,0,0,0,6.89-6.89l.06-8.91a6.76,6.76,0,0,0-6.74-6.74l-8.77,0a6.76,6.76,0,0,0-7,6.47C28,210.2,28,210.28,28,210.37Z",
    style: {
      fill: "#fb7558",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,237.84v8.94a6.9,6.9,0,0,0,6.89,6.89H43.6a6.89,6.89,0,0,0,6.89-6.89l.06-8.91a6.76,6.76,0,0,0-6.74-6.74l-8.77,0a6.77,6.77,0,0,0-7,6.47C28,237.67,28,237.76,28,237.84Z",
    style: {
      fill: "#fb7558",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.34,194.25v8.93a6.88,6.88,0,0,0,6.89,6.89H55a6.89,6.89,0,0,0,6.89-6.88l.06-8.92a6.75,6.75,0,0,0-6.74-6.73l-8.78,0a6.75,6.75,0,0,0-7,6.47A2.17,2.17,0,0,0,39.34,194.25Z",
    style: {
      fill: "#fb7558",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.34,215.75v8.93a6.88,6.88,0,0,0,6.89,6.89H55a6.89,6.89,0,0,0,6.89-6.88l.06-8.92A6.75,6.75,0,0,0,55.16,209l-8.78,0a6.75,6.75,0,0,0-7,6.47A2.17,2.17,0,0,0,39.34,215.75Z",
    style: {
      fill: "#fb7558",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37,212.76v8.93a6.89,6.89,0,0,0,6.89,6.89h8.72a6.89,6.89,0,0,0,6.89-6.88l.06-8.92a6.75,6.75,0,0,0-6.74-6.73L44,206a6.75,6.75,0,0,0-7,6.47A2.26,2.26,0,0,0,37,212.76Z",
    style: {
      fill: "#fb7558",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,201.41v8.94a6.9,6.9,0,0,0,6.89,6.89H43.6a6.9,6.9,0,0,0,6.89-6.89l.06-8.91a6.76,6.76,0,0,0-6.74-6.74l-8.77,0a6.77,6.77,0,0,0-7,6.47C28,201.24,28,201.33,28,201.41Z",
    style: {
      fill: "#fb7558",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.94,156.45v8.94a6.88,6.88,0,0,0,6.89,6.88h8.71a6.88,6.88,0,0,0,6.89-6.88l.06-8.92a6.75,6.75,0,0,0-6.73-6.73l-8.78,0a6.76,6.76,0,0,0-7,6.47Z",
    style: {
      fill: "#fb7558",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.61,156.45v8.94a6.89,6.89,0,0,0,6.89,6.88h8.72a6.89,6.89,0,0,0,6.89-6.88l.06-8.92a6.75,6.75,0,0,0-6.74-6.73l-8.77,0a6.76,6.76,0,0,0-7,6.47C29.62,156.28,29.61,156.36,29.61,156.45Z",
    style: {
      fill: "#fb7558",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.61,163.36v8.94a6.9,6.9,0,0,0,6.89,6.89h8.72a6.9,6.9,0,0,0,6.89-6.89l.06-8.91a6.76,6.76,0,0,0-6.74-6.74l-8.77,0a6.76,6.76,0,0,0-7,6.47C29.62,163.19,29.61,163.27,29.61,163.36Z",
    style: {
      fill: "#fb7558",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.17,165.66v8.94a6.89,6.89,0,0,0,6.89,6.89h8.72a6.88,6.88,0,0,0,6.88-6.89l.06-8.91A6.74,6.74,0,0,0,37,159l-8.78,0a6.77,6.77,0,0,0-7,6.47Z",
    style: {
      fill: "#fb7558",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.44,258.15v8.93A6.88,6.88,0,0,0,68.33,274h8.72a6.88,6.88,0,0,0,6.88-6.88l.06-8.92a6.75,6.75,0,0,0-6.73-6.73l-8.78,0a6.76,6.76,0,0,0-7,6.47Z",
    style: {
      fill: "#fb7558",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.56,150.05V159a6.9,6.9,0,0,0,6.89,6.89h8.72A6.9,6.9,0,0,0,57.06,159l.06-8.91a6.76,6.76,0,0,0-6.74-6.74l-8.77,0a6.76,6.76,0,0,0-7,6.47C34.57,149.88,34.56,150,34.56,150.05Z",
    style: {
      fill: "#fb7558",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.44,214.55v8.94a6.89,6.89,0,0,0,6.89,6.89h8.72a6.89,6.89,0,0,0,6.88-6.89l.06-8.91a6.75,6.75,0,0,0-6.73-6.74l-8.78,0a6.76,6.76,0,0,0-7,6.47Z",
    style: {
      fill: "#fb7558",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.79,224.11V233a6.88,6.88,0,0,0,6.88,6.89h8.72a6.88,6.88,0,0,0,6.89-6.88l.06-8.92a6.75,6.75,0,0,0-6.73-6.73l-8.78,0a6.76,6.76,0,0,0-7,6.47Z",
    style: {
      fill: "#fb7558",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.34,178.72v8.93a6.88,6.88,0,0,0,6.89,6.89h8.71a6.88,6.88,0,0,0,6.89-6.88l.06-8.92A6.75,6.75,0,0,0,84.16,172l-8.78,0a6.76,6.76,0,0,0-7,6.47Z",
    style: {
      fill: "#fb7558",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.31,190.07V199a6.89,6.89,0,0,0,6.89,6.89h8.72A6.9,6.9,0,0,0,96.81,199l.06-8.91a6.75,6.75,0,0,0-6.74-6.73l-8.78,0a6.75,6.75,0,0,0-7,6.47A2.17,2.17,0,0,0,74.31,190.07Z",
    style: {
      fill: "#fb7558",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 9.56,
    r: 9.56,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.66,15.24a9.55,9.55,0,1,0-15.37-.05l-19.78,42,1.81.85L43.75,16.78A9.57,9.57,0,0,0,49,19.06V55.5h2V19.06a9.48,9.48,0,0,0,5.19-2.25L75.67,58.06l1.81-.85ZM50,17.11a7.56,7.56,0,1,1,7.55-7.55A7.56,7.56,0,0,1,50,17.11Z",
    style: {
      fill: "#b5b5b5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 55,
    width: 100,
    height: 286,
    rx: 32,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68,341H32A32,32,0,0,1,0,309V87A32,32,0,0,1,32,55H68a32,32,0,0,1,32,32V309A32,32,0,0,1,68,341ZM32,57A30,30,0,0,0,2,87V309a30,30,0,0,0,30,30H68a30,30,0,0,0,30-30V87A30,30,0,0,0,68,57Z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxbag);
export default __webpack_public_path__ + "static/media/boxbag.008705ec1decd1e142b74f7dc92bc3cc.svg";
export { ForwardRef as ReactComponent };